import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import ActionSheetContext from './ActionSheetContext';

const ActionSheetCloseButton = ({ className, children }) => {
  const { isVisible, setIsVisible } = React.useContext(ActionSheetContext);
  const cn = useClassNames(
    () => [
      'shadow-lg',
      'mb-4',
      'py-5',
      'px-6',
      'rounded-lg',
      'h-auto',
      'text-red-600',
      'bg-white',
      'hover:bg-slate-50',
      'focus:outline-none',
      'select-none',
      className,
    ],
    [className],
  );

  return (
    <button
      className={cn}
      onClick={e => {
        e.stopPropagation();
        setIsVisible(!isVisible);
      }}
      type="button"
    >
      {children}
    </button>
  );
};

ActionSheetCloseButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ActionSheetCloseButton;
